<template>
  <div v-if="isOffline" class="offline-overlay" role="alert" aria-live="assertive">
    <div class="offline-message">
      <i class="fas fa-wifi offline-icon"></i>
      <div class="offline-title">Nincs internetkapcsolat</div>
      <div class="offline-text">
        Az alkalmazás jelenleg offline állapotban van. Kérjük, ellenőrizze az internetkapcsolatot.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfflineOverlay",
  data() {
    return {
      isOffline: typeof navigator !== "undefined" ? !navigator.onLine : false,
    };
  },
  mounted() {
    window.addEventListener("online", this.handleOnlineStatusChange);
    window.addEventListener("offline", this.handleOnlineStatusChange);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.handleOnlineStatusChange);
    window.removeEventListener("offline", this.handleOnlineStatusChange);
  },
  methods: {
    handleOnlineStatusChange() {
      this.isOffline = !navigator.onLine;
    },
  },
};
</script>

<style lang="scss" scoped>
.offline-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(2px);
}

.offline-message {
  max-width: 420px;
  width: 100%;
  padding: 28px 24px;
  border-radius: 20px;
  color: #252734;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.16);
  text-align: center;
  font-family: "Poppins", sans-serif;
}

.offline-icon {
  margin-bottom: 14px;
  color: #F88379;
  font-size: 36px;
}

.offline-title {
  margin-bottom: 8px;
  font-family: "Jumper";
  font-size: 22px;
  font-weight: 700;
}

.offline-text {
  font-size: 14px;
  line-height: 1.5;
}
</style>
